module.exports = "../study/imgs/maps/Tokyo/S8/Ecosystem/Avietchii/Tokyo_Avietchii_HadGEM2_RCP45_End.png";